module.exports = __webpack_public_path__ + "static/media/avatar44.07a9f5d6.png";